import styled from "styled-components";
import {radii} from "theme/tokens";

/**
 * The button at the right edge of "Your name" that chooses who a request is sent as: the current choice's icon
 * and a caret, on the field's own surface, warming to the hairline colour under a pointer. A 36px target that
 * fits inside the filled field's height.
 */
export const SenderKindButton = styled.button`
	display: inline-flex;
	align-items: center;
	gap: 1px;
	height: 36px;
	padding: 0 4px 0 8px;
	border: 0;
	border-radius: ${radii.control};
	background: transparent;
	color: ${({theme}) => theme.tokens.ink2};
	cursor: pointer;
	transition: background 0.14s, color 0.14s;

	&:hover {
		background: ${({theme}) => theme.tokens.line};
		color: ${({theme}) => theme.tokens.ink};
	}

	&:focus-visible {
		outline: 2px solid ${({theme}) => theme.tokens.focusOutline};
		outline-offset: 2px;
	}

	&:disabled {
		cursor: default;
		opacity: 0.5;
	}
`;

/** The company's two fields, stacked at the builder's own 14px field gap. */
export const CompanyFields = styled.div`
	display: flex;
	flex-direction: column;
	gap: 14px;
`;

/** The tax ID's hint, or what is wrong with it, under its field. */
export const FieldNote = styled.p<{$error: boolean}>`
	margin: 4px 0 0 12px;
	font-size: 12.5px;
	line-height: 1.45;
	color: ${({theme, $error}) => ($error ? theme.tokens.errorInk : theme.tokens.ink2)};
`;
